import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
export default class GeneralSearchIndex {
  constructor() {
    _defineProperty(this, "currentId", '');
    _defineProperty(this, "data", {});
    _defineProperty(this, "groups", {});
  }
  group(id, data) {
    this.groups[id] = data;
    return this;
  }
  for(id) {
    this.currentId = id;
    return this;
  }
  add(type, items) {
    var _this$data, _this$currentId;
    (_this$data = this.data)[_this$currentId = this.currentId] || (_this$data[_this$currentId] = {
      settings: [],
      permissions: []
    });
    this.data[this.currentId][type].push(...items);
  }
  getData() {
    return this.data;
  }
  getGroup(id) {
    return this.groups[id] || null;
  }
}
flarum.reg.add('core', 'admin/states/GeneralSearchIndex', GeneralSearchIndex);